export default "__VITE_ASSET__DFQW73rf__"